import { knowledgeItems } from "../../data/products";

/** A Help Center tutorial video, as the Video Tutorials page lists it. */
export type HelpVideo = {
  id: string;
  title: string;
  description: string;
  duration: string;
  category: string;
  videoPath: string;
  tags: string[];
  thumbnail: string;
};

export const HELP_VIDEOS: HelpVideo[] = [
  {
    id: "why-noticeboard",
    title: "Why Noticeboard",
    description: "Discover how Noticeboard can transform communication in your organization",
    duration: "2:30",
    category: "Getting Started",
    videoPath: "/videos/whynoticeboard.mp4",
    tags: ["introduction", "overview", "getting started"],
    thumbnail: "/videos/whynoticeboard.webp",
  },
  {
    id: "create-notice",
    title: "How to Create a Notice",
    description: "Step-by-step guide to creating your first notice using the Creation Wizard",
    duration: "3:45",
    category: "Core Features",
    videoPath: "/videos/createnotice.webm",
    tags: ["notices", "creation", "wizard", "tutorial"],
    thumbnail: "/videos/createnotice.webp",
  },
  {
    id: "create-event",
    title: "How to Create an Event",
    description: "Learn how to create event notices with dates, times, and locations",
    duration: "4:20",
    category: "Core Features",
    videoPath: "/videos/createevent.webm",
    tags: ["events", "calendar", "scheduling", "tutorial"],
    thumbnail: "/videos/createevent.webp",
  },
  {
    id: "create-circle",
    title: "How to Create a Circle",
    description: "Learn how to create and manage communication circles for your organization",
    duration: "5:15",
    category: "Administration",
    videoPath: "/videos/createcircle.webm",
    tags: ["circles", "administration", "organization", "tutorial"],
    thumbnail: "/videos/createcircle.webp",
  },
  {
    id: "add-user",
    title: "How to Add Users",
    description: "Learn how to add new users and manage user accounts in your organization",
    duration: "4:45",
    category: "Administration",
    videoPath: "/videos/adduser.webm",
    tags: ["users", "administration", "accounts", "tutorial"],
    thumbnail: "/videos/adduser.webp",
  },
];

export const HELP_VIDEOS_PATH = "/help/videos";

/** Router state that opens Video Tutorials playing one video. */
export type HelpVideosState = { play?: string };

export const toHelpVideo = (id: string) => ({
  pathname: HELP_VIDEOS_PATH,
  state: { play: id } as HelpVideosState,
});

/** The video Video Tutorials was asked to play on arrival, if any. */
export const videoToPlay = (state: unknown): HelpVideo | undefined =>
  HELP_VIDEOS.find((v) => v.id === (state as HelpVideosState | null)?.play);

/** A help article with its own page, titled as the page shows it. */
export type HelpArticle = { id: string; title: string; tags: string[]; path: string };

/** Each help article page and the help content it shows. */
const ARTICLE_PATHS: Record<string, string> = {
  noticeboard: "/help/noticeboard",
  notices: "/help/notices",
  calendar: "/help/calendar",
  circles: "/help/circles",
  login: "/help/login-auth",
};

export const HELP_ARTICLES: HelpArticle[] = knowledgeItems
  .filter((item) => ARTICLE_PATHS[item.id])
  .map(({ id, title, tags }) => ({ id, title, tags, path: ARTICLE_PATHS[id] }));
